import API from '@/services/http'
import { DictionaryInfo } from '@/store/addressSlice/types'

interface providerLogoRespVos {
  /**服务商编码 */
  providerCode?: string
  /**服务商名称 */
  providerName?: string
  /**服务商logo地址 */
  logoUrl?: string
}

/**
 * 字典配置查询
 * @returns
 */
export const queryDictionary = () => API.admin.post<{ providerLogoRespVos: providerLogoRespVos[] }>('/api/provider/logo/list?_sw_cache=15')

export type DictinaryKeyMap = 'COUNTRY_PHONE_AREA_CODE' | 'STATION_TYPE_DICT' | 'COUNTRY_LIST' | 'ONESHIP_COMMON_SETTING' | 'COUNTRY_PHONE_AREA_CODE'

/**
 * 整合所有字典配置查询
 * @returns
 */
export const fetchDictionaryByKey = (key: DictinaryKeyMap) =>
  API.admin.post<{ dictionaryInfos: DictionaryInfo[] }>(`/api/dictionary_query/list/v2`, { group: key }, { params: { group: key } })

/**
 * 用户国家所有的服务商
 * @returns
 */
export const fetchProviderList = () => API.normal.post<{ providerLogoRespVos: providerLogoRespVos[] }>('/api/provider/oneship/list')
